import React from 'react';

import { Newsletter } from '../../../hooks/useCurrentNewsletter';
import {
  create_user_path,
  highlight_path,
  newsletter_post_signup_path,
  static_privacy_path,
  subscribe_promotion_path,
} from '../../../routes';
import { DEFAULT_ANNUAL_OFFER_CODE } from '../../../src/constants';
import LockedLeadCaptureForm from '../../shared/LockedLeadCaptureForm';
import NewsletterSignupButton from './NewsletterSignupButton';
import styles from './styles.module.scss';

interface NewsletterSignupProps {
  currentUserAccessLevel: number;
  isLoggedIn: boolean;
  gdprColorScheme: string;
  gdpr: boolean;
  isSubscribed: boolean;
  newsletter: Newsletter;
}

const NewsletterSignUp = ({
  currentUserAccessLevel,
  isLoggedIn,
  gdpr,
  gdprColorScheme,
  isSubscribed,
  newsletter,
}: NewsletterSignupProps) => {
  const canSubscribe = currentUserAccessLevel >= newsletter.accessLevel;

  return (
    <div className={styles.newsletterSignUp}>
      {isLoggedIn ? (
        <NewsletterSignupButton
          canSubscribe={canSubscribe}
          currentUserAccessLevel={currentUserAccessLevel}
          isSubscribed={isSubscribed}
          newsletter={newsletter}
        />
      ) : (
        <>
          {gdpr && (
            <div className={`marketing-opt-in-container ${gdprColorScheme} `}>
              <label className="marketing-opt-in">
                <span className="form-control-text">
                  Get Breaking News, Relevant Stories, and Special Event &amp; Editorial Invites
                </span>
                <input type="checkbox" value="1" name="user[opt_in]" className="opt-in" required />
                <span className="checkbox-fill"></span>
              </label>
            </div>
          )}
          <LockedLeadCaptureForm
            buttonText="Sign Up"
            endpointUri={
              canSubscribe
                ? create_user_path({ newsletter_ids: [newsletter.id] })
                : create_user_path()
            }
            redirectUri={
              canSubscribe
                ? newsletter_post_signup_path({
                    id: newsletter.id,
                  })
                : subscribe_promotion_path({
                    offer: newsletter.offer?.code || DEFAULT_ANNUAL_OFFER_CODE,
                    redirect_to: highlight_path({ highlight: newsletter.slug }),
                  })
            }
            leadType={`${newsletter.name.replace(' ', '_').toLowerCase()}_newsletter_lead_type`}
            trackingProps={{
              name: 'newsletter_subscribe',
              'lead-details': JSON.stringify({ newsletter_name: newsletter.name }),
            }}
          />
          <div className={styles.privacy}>
            By Providing Your Email, You Agree To The Information&rsquo;s{' '}
            <a href={static_privacy_path()}>Privacy Policy</a>
          </div>
        </>
      )}
    </div>
  );
};

export default NewsletterSignUp;
